import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { colorsV2 } from 'style/colors-v2';

const StyledA = styled.a`
  display: inline-flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  color: ${colorsV2.primary100};
  padding-left: 10px;
  padding-right: 6px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 24px;
  border: 1px solid transparent;
  background-color: transparent;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${colorsV2.primary10};
  }
`;

const IconWrapper = styled.span`
  display: inline-block;

  svg {
    display: block;
  }

  path {
    fill: currentColor;
  }
`;

const LinkButton = ({
  children,
  href,
  isExternal = false,
  newTab = false,
  icon = null,
  ...restProps
}) => {
  if (isExternal) {
    return (
      <StyledA
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...restProps}
      >
        {children} {icon && <IconWrapper>{icon}</IconWrapper>}
      </StyledA>
    );
  }

  return (
    <StyledA
      to={href}
      target={newTab ? '_blank' : '_self'}
      as={Link}
      {...restProps}
    >
      {children} {icon && <IconWrapper>{icon}</IconWrapper>}
    </StyledA>
  );
};

export default LinkButton;
